<script>
import RexSearchSelect from '@/rex-components/RexSearchSelect.vue';
import RexModalLabel from '@/rex-components/rex-modal-label.vue';
import {
  METRIC,
  INSTANCE,
  CUSTOM_METRIC,
  CUSTOM_POSTGRES_METRICS,
  DATABSE,
} from '@/components/AlertsV2/constants';
import { dbTypeMapper } from '@/components/AlertsV2/alertsV2Utils';
import { mapGetters, mapActions } from 'vuex';
import { parseServiceObjFromApplication } from '@/utils/helper-function';

export default {
  components: { RexSearchSelect, RexModalLabel },
  props: {
    serviceIdObj: {
      type: Object,
      default: () => ({}),
    },
    currentMetricObj: {
      type: Object,
      default: () => ({}),
    },
    selectedFields: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters('alertV2State/configure', ['getCurrentAlertApplication']),
    getDBType() {
      return parseServiceObjFromApplication(this.getCurrentAlertApplication)
        ?.sub;
    },
    getLabelHeader() {
      if (
        this.getDBType === 'MS' &&
        this.currentMetricObj.key !== CUSTOM_METRIC
      ) {
        return this.$t('alert.database');
      } else if (this.type === METRIC) {
        return this.$t('alert.metricName');
      }
      return this.$t('alert.instance');
    },
    getSearchText() {
      if (
        this.getDBType === 'MS' &&
        this.currentMetricObj.key !== CUSTOM_METRIC
      ) {
        return this.$t('alert.seachDatabase');
      } else if (this.type === METRIC) {
        return this.$t('alert.searchMetric');
      }
      return this.$t('alert.searchInstance');
    },
    getMultiSelectedText() {
      let selectedType = this.type;
      if (
        this.getDBType === 'MS' &&
        this.currentMetricObj.key !== CUSTOM_METRIC
      ) {
        selectedType = DATABSE;
      }
      const selectedLen = this.selectedInstancesKeys.length;
      const selectedKey =
        selectedLen === 1
          ? `alert.${selectedType}Selected`
          : `alert.${selectedType}sSelected`;

      return selectedLen === 0
        ? this.$t('alert.selectFromAvailable')
        : this.$t(selectedKey, [selectedLen]);
    },
  },
  data() {
    return {
      instances: [],
      selectedInstancesKeys: [],
      type:
        this.currentMetricObj.key === CUSTOM_METRIC ||
        this.currentMetricObj.key === CUSTOM_POSTGRES_METRICS
          ? METRIC
          : INSTANCE,
      currentDBType: '',
    };
  },
  methods: {
    ...mapActions('alertV2State/configure', [
      'GET_INSTANCE_BY_META',
      'GET_INSTANCES',
    ]),
    formatInstances(instanceArr) {
      return instanceArr.map((obj) => ({
        key: obj.label,
        label: obj.label,
        selected: this.selectedInstancesKeys?.includes(obj.label) || false,
      }));
    },
    async getInstances() {
      this.instances = [];
      this.selectedInstancesKeys = [];
      if (this.type === METRIC) {
        try {
          const params = {
            serviceId: this.serviceIdObj.key,
            properties: [{ key: 'metaProperty3', value: 'CDQ' }],
          };
          const { instanceId } = await this.GET_INSTANCE_BY_META(params);
          this.instances = this.formatInstances(instanceId);
        } catch (error) {
          console.log('error', error);
        }
      } else {
        const currentDbType = parseServiceObjFromApplication(
          this.getCurrentAlertApplication,
        )?.sub;
        const serviceInstance = {
          serviceId: this.serviceIdObj.key,
          properties: {
            key: 'instance_type',
            value: dbTypeMapper[currentDbType],
          },
        };
        const instanceId = await this.GET_INSTANCES(serviceInstance);
        this.instances = this.formatInstances(instanceId);
      }
    },
    handleMultiSelect(item) {
      this.instances = this.instances.map((obj) => {
        if (obj.key === item.key) obj.selected = !obj.selected;
        return obj;
      });
      this.selectedInstancesKeys = this.instances
        .filter((obj) => obj.selected)
        .map((obj) => obj.key);
      this.$emit('onMultiSelect', this.selectedInstancesKeys);
    },
  },
  mounted() {
    this.getInstances();
  },
  watch: {
    currentMetricObj(newValue) {
      if (
        newValue.key === CUSTOM_METRIC ||
        newValue.key === CUSTOM_POSTGRES_METRICS
      ) {
        this.type = METRIC;
      } else {
        this.type = INSTANCE;
      }
      this.getInstances();
    },
    selectedFields(newVal) {
      this.selectedInstancesKeys = newVal;
      this.instances.map((obj) => {
        obj.selected = newVal.includes(obj.key);
        return obj;
      });
    },
  },
};
</script>

<template>
  <div class="couch-base-type-box">
    <RexModalLabel :primaryLabel="getLabelHeader + $t('asterisk')" />

    <RexSearchSelect
      :isEdit="true"
      :data="instances"
      :objectValueIndex="1"
      :boldActive="true"
      :isSearch="true"
      :searchPlaceholder="getSearchText"
      :multiSelect="true"
      id="alert-form-field-couchbase-type"
      @onMultiSelect="handleMultiSelect"
      :multiSelectTitle="getMultiSelectedText"
      :useParentData="true"
    />
  </div>
</template>

<style lang="scss" scoped>
.couch-base-type-box {
  margin-top: 1.5rem;
}
.max-width {
  max-width: 20.75em !important;
}
</style>
